import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { debounce } from '../../utils/debounce.js';
import { CloudImageEditorBase } from './CloudImageEditorBase.js';
import { EditorCropButtonControl } from './EditorCropButtonControl.js';
import { EditorFilterControl } from './EditorFilterControl.js';
import { EditorOperationControl } from './EditorOperationControl.js';
import { FAKE_ORIGINAL_FILTER } from './EditorSlider.js';
import { batchPreloadImages } from './lib/preloadImage.js';
import { ALL_COLOR_OPERATIONS, ALL_CROP_OPERATIONS, ALL_FILTERS, ALL_TABS, COLOR_OPERATIONS_CONFIG, TabId } from './toolbar-constants.js';
import { viewerImageSrc } from './util.js';

/** @param {String} id */
function renderTabToggle(id) {
  return /* HTML */"\n    <lr-presence-toggle class=\"tab-toggle\" set=\"visible: presence.tabToggle.".concat(id, "; styles: presence.tabToggleStyles;\">\n      <lr-btn-ui\n        theme=\"boring\"\n        ref=\"tab-toggle-").concat(id, "\"\n        data-id=\"").concat(id, "\"\n        icon=\"").concat(id, "\"\n        tabindex=\"0\"\n        set=\"onclick: on.clickTab;\"\n      >\n      </lr-btn-ui>\n    </lr-presence-toggle>\n  ");
}

/** @param {String} id */
function renderTabContent(id) {
  return /* HTML */"\n    <lr-presence-toggle class=\"tab-content\" set=\"visible: presence.tabContent.".concat(id, "; styles: presence.tabContentStyles\">\n      <lr-editor-scroller hidden-scrollbar>\n        <div class=\"controls-list_align\">\n          <div class=\"controls-list_inner\" ref=\"controls-list-").concat(id, "\"></div>\n        </div>\n      </lr-editor-scroller>\n    </lr-presence-toggle>\n  ");
}
export class EditorToolbar extends CloudImageEditorBase {
  constructor() {
    super();
    _defineProperty(this, "_updateInfoTooltip", debounce(() => {
      const transformations = this.$['*editorTransformations'];
      /** @type {keyof COLOR_OPERATIONS_CONFIG} */
      const currentOperation = this.$['*currentOperation'];
      let text = '';
      let visible = false;
      if (this.$['*tabId'] === TabId.FILTERS) {
        var _transformations$filt;
        visible = true;
        if (this.$['*currentFilter'] && (transformations === null || transformations === void 0 || (_transformations$filt = transformations.filter) === null || _transformations$filt === void 0 ? void 0 : _transformations$filt.name) === this.$['*currentFilter']) {
          var _transformations$filt2;
          let value = (transformations === null || transformations === void 0 || (_transformations$filt2 = transformations.filter) === null || _transformations$filt2 === void 0 ? void 0 : _transformations$filt2.amount) || 100;
          text = this.l10n(this.$['*currentFilter']) + ' ' + value;
        } else {
          text = this.l10n(FAKE_ORIGINAL_FILTER);
        }
      } else if (this.$['*tabId'] === TabId.TUNING && currentOperation) {
        visible = true;
        let value = (transformations === null || transformations === void 0 ? void 0 : transformations[currentOperation]) || COLOR_OPERATIONS_CONFIG[currentOperation].zero;
        text = currentOperation + ' ' + value;
      }
      if (visible) {
        this.$['*operationTooltip'] = text;
      }
      this.ref['tooltip-el'].classList.toggle('info-tooltip_visible', visible);
    }, 0));
    this.init$ = _objectSpread(_objectSpread({}, this.init$), {}, {
      '*sliderEl': null,
      /** @type {import('./types.js').LoadingOperations} */
      '*loadingOperations': new Map(),
      '*showSlider': false,
      '*currentFilter': FAKE_ORIGINAL_FILTER,
      '*currentOperation': null,
      showLoader: false,
      filters: ALL_FILTERS,
      colorOperations: ALL_COLOR_OPERATIONS,
      cropOperations: ALL_CROP_OPERATIONS,
      '*operationTooltip': null,
      'l10n.cancel': this.l10n('cancel'),
      'l10n.apply': this.l10n('apply'),
      'presence.mainToolbar': true,
      'presence.subToolbar': false,
      'presence.tabToggles': true,
      'presence.tabContent.crop': false,
      'presence.tabContent.tuning': false,
      'presence.tabContent.filters': false,
      'presence.tabToggle.crop': true,
      'presence.tabToggle.tuning': true,
      'presence.tabToggle.filters': true,
      'presence.subTopToolbarStyles': {
        hidden: 'sub-toolbar--top-hidden',
        visible: 'sub-toolbar--visible'
      },
      'presence.subBottomToolbarStyles': {
        hidden: 'sub-toolbar--bottom-hidden',
        visible: 'sub-toolbar--visible'
      },
      'presence.tabContentStyles': {
        hidden: 'tab-content--hidden',
        visible: 'tab-content--visible'
      },
      'presence.tabToggleStyles': {
        hidden: 'tab-toggle--hidden',
        visible: 'tab-toggle--visible'
      },
      'presence.tabTogglesStyles': {
        hidden: 'tab-toggles--hidden',
        visible: 'tab-toggles--visible'
      },
      'on.cancel': () => {
        this._cancelPreload && this._cancelPreload();
        this.$['*on.cancel']();
      },
      'on.apply': () => {
        this.$['*on.apply'](this.$['*editorTransformations']);
      },
      'on.applySlider': () => {
        this.ref['slider-el'].apply();
        this._onSliderClose();
      },
      'on.cancelSlider': () => {
        this.ref['slider-el'].cancel();
        this._onSliderClose();
      },
      /** @param {MouseEvent} e */
      'on.clickTab': e => {
        const id = /** @type {HTMLElement} */e.currentTarget.getAttribute('data-id');
        if (id) {
          this._activateTab(id, {
            fromViewer: false
          });
        }
      }
    });

    /** @private */

    this._debouncedShowLoader = debounce(this._showLoader.bind(this), 500);
  }

  /** @private */
  _onSliderClose() {
    this.$['*showSlider'] = false;
    if (this.$['*tabId'] === TabId.TUNING) {
      this.ref['tooltip-el'].classList.toggle('info-tooltip_visible', false);
    }
  }

  /**
   * @private
   * @param {String} operation
   */
  _createOperationControl(operation) {
    let el = new EditorOperationControl();
    // @ts-expect-error TODO: fix
    el.operation = operation;
    return el;
  }

  /**
   * @private
   * @param {String} filter
   */
  _createFilterControl(filter) {
    let el = new EditorFilterControl();
    // @ts-expect-error TODO: fix
    el.filter = filter;
    return el;
  }

  /**
   * @private
   * @param {String} operation
   */
  _createToggleControl(operation) {
    let el = new EditorCropButtonControl();
    // @ts-expect-error TODO: fix
    el.operation = operation;
    return el;
  }

  /**
   * @private
   * @param {String} tabId
   */
  _renderControlsList(tabId) {
    let listEl = this.ref["controls-list-".concat(tabId)];
    let fr = document.createDocumentFragment();
    if (tabId === TabId.CROP) {
      this.$.cropOperations.forEach(/** @param {string} operation */operation => {
        let el = this._createToggleControl(operation);
        // @ts-ignore
        fr.appendChild(el);
      });
    } else if (tabId === TabId.FILTERS) {
      [FAKE_ORIGINAL_FILTER, ...this.$.filters].forEach(filterId => {
        let el = this._createFilterControl(filterId);
        // @ts-ignore
        fr.appendChild(el);
      });
    } else if (tabId === TabId.TUNING) {
      this.$.colorOperations.forEach(/** @param {string} operation */operation => {
        let el = this._createOperationControl(operation);
        // @ts-ignore
        fr.appendChild(el);
      });
    }
    [...fr.children].forEach((el, idx) => {
      if (idx === fr.childNodes.length - 1) {
        el.classList.add('controls-list_last-item');
      }
    });
    listEl.innerHTML = '';
    listEl.appendChild(fr);
  }

  /**
   * @private
   * @param {String} id
   * @param {{ fromViewer?: Boolean }} options
   */
  _activateTab(id, _ref) {
    let {
      fromViewer
    } = _ref;
    this.$['*tabId'] = id;
    if (id === TabId.CROP) {
      this.$['*faderEl'].deactivate();
      this.$['*cropperEl'].activate(this.$['*imageSize'], {
        fromViewer
      });
    } else {
      this.$['*faderEl'].activate({
        url: this.$['*originalUrl'],
        fromViewer
      });
      this.$['*cropperEl'].deactivate();
    }
    for (let tabId of ALL_TABS) {
      let isCurrentTab = tabId === id;
      let tabToggleEl = this.ref["tab-toggle-".concat(tabId)];
      tabToggleEl.active = isCurrentTab;
      if (isCurrentTab) {
        this._renderControlsList(id);
        this._syncTabIndicator();
      } else {
        this._unmountTabControls(tabId);
      }
      this.$["presence.tabContent.".concat(tabId)] = isCurrentTab;
    }
  }

  /**
   * @private
   * @param {String} tabId
   */
  _unmountTabControls(tabId) {
    let listEl = this.ref["controls-list-".concat(tabId)];
    if (listEl) {
      listEl.innerHTML = '';
    }
  }

  /** @private */
  _syncTabIndicator() {
    let tabToggleEl = this.ref["tab-toggle-".concat(this.$['*tabId'])];
    let indicatorEl = this.ref['tabs-indicator'];
    indicatorEl.style.transform = "translateX(".concat(tabToggleEl.offsetLeft, "px)");
  }

  /** @private */
  _preloadEditedImage() {
    if (this.$['*imgContainerEl'] && this.$['*originalUrl']) {
      let width = this.$['*imgContainerEl'].offsetWidth;
      let src = this.proxyUrl(viewerImageSrc(this.$['*originalUrl'], width, this.$['*editorTransformations']));
      this._cancelPreload && this._cancelPreload();
      let {
        cancel
      } = batchPreloadImages([src]);
      this._cancelPreload = () => {
        cancel();
        this._cancelPreload = undefined;
      };
    }
  }

  /**
   * @private
   * @param {boolean} show
   */
  _showLoader(show) {
    this.$.showLoader = show;
  }
  initCallback() {
    super.initCallback();
    this.$['*sliderEl'] = this.ref['slider-el'];
    this.sub('*imageSize', imageSize => {
      if (imageSize) {
        setTimeout(() => {
          this._activateTab(this.$['*tabId'], {
            fromViewer: true
          });
        }, 0);
      }
    });
    this.sub('*editorTransformations', editorTransformations => {
      var _editorTransformation;
      let appliedFilter = editorTransformations === null || editorTransformations === void 0 || (_editorTransformation = editorTransformations.filter) === null || _editorTransformation === void 0 ? void 0 : _editorTransformation.name;
      if (this.$['*currentFilter'] !== appliedFilter) {
        this.$['*currentFilter'] = appliedFilter;
      }
    });
    this.sub('*currentFilter', () => {
      this._updateInfoTooltip();
    });
    this.sub('*currentOperation', () => {
      this._updateInfoTooltip();
    });
    this.sub('*tabId', () => {
      this._updateInfoTooltip();
    });
    this.sub('*originalUrl', () => {
      this.$['*faderEl'] && this.$['*faderEl'].deactivate();
    });
    this.sub('*editorTransformations', transformations => {
      this._preloadEditedImage();
      if (this.$['*faderEl']) {
        this.$['*faderEl'].setTransformations(transformations);
      }
    });
    this.sub('*loadingOperations', (/** @type {import('./types.js').LoadingOperations} */loadingOperations) => {
      let anyLoading = false;
      for (let [, mapping] of loadingOperations.entries()) {
        if (anyLoading) {
          break;
        }
        for (let [, loading] of mapping.entries()) {
          if (loading) {
            anyLoading = true;
            break;
          }
        }
      }
      this._debouncedShowLoader(anyLoading);
    });
    this.sub('*showSlider', showSlider => {
      this.$['presence.subToolbar'] = showSlider;
      this.$['presence.mainToolbar'] = !showSlider;
    });
    this.sub('*tabList', tabList => {
      this.$['presence.tabToggles'] = tabList.length > 1;
      for (const tabId of ALL_TABS) {
        this.$["presence.tabToggle.".concat(tabId)] = tabList.includes(tabId);
        const toggleEl = this.ref["tab-toggle-".concat(tabId)];
        toggleEl.style.gridColumn = tabList.indexOf(tabId) + 1;
      }
      if (!tabList.includes(this.$['*tabId'])) {
        this._activateTab(tabList[0], {
          fromViewer: false
        });
      }
    });
    this._updateInfoTooltip();
  }
}
EditorToolbar.template = /* HTML */"\n  <lr-line-loader-ui set=\"active: showLoader\"></lr-line-loader-ui>\n  <div class=\"info-tooltip_container\">\n    <div class=\"info-tooltip_wrapper\">\n      <div ref=\"tooltip-el\" class=\"info-tooltip info-tooltip_hidden\">{{*operationTooltip}}</div>\n    </div>\n  </div>\n  <div class=\"toolbar-container\">\n    <lr-presence-toggle class=\"sub-toolbar\" set=\"visible: presence.mainToolbar; styles: presence.subTopToolbarStyles\">\n      <div class=\"tab-content-row\">".concat(ALL_TABS.map(renderTabContent).join(''), "</div>\n      <div class=\"controls-row\">\n        <lr-btn-ui theme=\"boring\" icon=\"closeMax\" set=\"onclick: on.cancel\"> </lr-btn-ui>\n        <lr-presence-toggle class=\"tab-toggles\" set=\"visible: presence.tabToggles; styles: presence.tabTogglesStyles\">\n          <div ref=\"tabs-indicator\" class=\"tab-toggles_indicator\"></div>\n          ").concat(ALL_TABS.map(renderTabToggle).join(''), "\n        </lr-presence-toggle>\n        <lr-btn-ui theme=\"primary\" icon=\"done\" set=\"onclick: on.apply\"> </lr-btn-ui>\n      </div>\n    </lr-presence-toggle>\n    <lr-presence-toggle class=\"sub-toolbar\" set=\"visible: presence.subToolbar; styles: presence.subBottomToolbarStyles\">\n      <div class=\"slider\">\n        <lr-editor-slider ref=\"slider-el\"></lr-editor-slider>\n      </div>\n      <div class=\"controls-row\">\n        <lr-btn-ui theme=\"boring\" set=\"@text: l10n.cancel; onclick: on.cancelSlider;\"> </lr-btn-ui>\n        <lr-btn-ui theme=\"primary\" set=\"@text: l10n.apply; onclick: on.applySlider;\"> </lr-btn-ui>\n      </div>\n    </lr-presence-toggle>\n  </div>\n");